import {DatePicker, Label, Option, Select} from "@ui5/webcomponents-react";
import {useEffect, useState} from "react";

export type SentViaOption = 'email' | 'URL';

interface SentViaProps {
    onSentViaChange: (sentVia: SentViaOption) => void;
    onValidUntilChange: (validUntil: string | undefined) => void;
}

function toIsoDate(date: Date): string {
    return date.toISOString().substring(0, 10);
}

export function SentVia(props: SentViaProps) {
    const [sentVia, setSentVia] = useState<SentViaOption>('email');
    const [validUntil, setValidUntil] = useState('');

    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 1);
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 30);

    useEffect(() => {
        props.onSentViaChange(sentVia);
    }, [sentVia]);

    useEffect(() => {
        props.onValidUntilChange(sentVia === 'URL' ? validUntil : undefined);
    }, [sentVia, validUntil]);

    return <>
        <div className={"sc_filter"}>
            <Label className="sc_label">sent via</Label>
            <Select
                className="sc_input"
                onChange={ev => setSentVia(ev.detail.selectedOption.value as SentViaOption)}
            >
                <Option value="email" selected={sentVia === 'email'}>email</Option>
                <Option value="URL" selected={sentVia === 'URL'}>URL</Option>
            </Select>
        </div>
        {sentVia === 'URL' && <div className={"sc_filter"}>
            <Label className="sc_label">valid until</Label>
            <DatePicker
                className="sc_input"
                minDate={toIsoDate(minDate)}
                maxDate={toIsoDate(maxDate)}
                value={validUntil}
                onChange={ev => ev.detail.valid && setValidUntil(ev.detail.value)}
            />
        </div>}
    </>;
}
